export default function Highlight({ code }: { code: string }) {
  return (
    <div className='overflow-auto'>
      <pre className='text-left'>
        <code className='text-sm text-gray-600'>{code}</code>
      </pre>
    </div>
  );
}
